import * as React from "react";

import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import "../css/style.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


export default function BldInfo(props) {
  const { handleClose, data,id, open, text_rooms} = props;

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          <Typography id="transition-modal-title" variant="h6" component="h2">
           {text_rooms}:
          </Typography>
          
          {data.filter(e=>e.building_id == id).map(e=> (<Typography id="transition-modal-description" sx={{ mt: 2 }} style={{whiteSpace: 'pre-wrap' }}>
             {e.number}
          </Typography>))}
          
          
        </Box>
      </Fade>
    </Modal>
  );
}
